package analytics

import kotlinx.serialization.json.JsonArray
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonObject
import kotlinx.serialization.json.JsonPrimitive
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put

internal fun Map<String, Any?>.toJsonObject(): JsonObject = buildJsonObject {
    forEach { (key, value) ->
        val element = value.toJsonElement() ?: return@forEach
        put(key, element)
    }
}

internal fun Any?.toJsonElement(): JsonElement? = when (this) {
    null -> null
    is JsonElement -> this
    is String -> JsonPrimitive(this)
    is Boolean -> JsonPrimitive(this)
    is Int -> JsonPrimitive(this)
    is Long -> JsonPrimitive(this)
    is Float -> JsonPrimitive(this.toDouble())
    is Double -> JsonPrimitive(this)
    is Number -> JsonPrimitive(this.toDouble())
    is Map<*, *> -> {
        @Suppress("UNCHECKED_CAST")
        (this as Map<String, Any?>).toJsonObject()
    }
    is Iterable<*> -> JsonArray(mapNotNull { it.toJsonElement() })
    else -> JsonPrimitive(toString())
}
